// API routes pro diskuze

const basePath = (threadId: string) => {
  return `/threadwrite/${threadId}/1`;
};

// Přidat / Odpověďět
export const reply = (threadId: string) => {
  return `${basePath(threadId)}/reply`;
};

// Smazat / Obnovit / Nezávadný
// Název nemůže být delete vzhledem ke strict mode
export const status = (threadId: string) => {
  return `${basePath(threadId)}/msg_status`;
};

// Nahlásit
export const notify = (threadId: string) => {
  return `${basePath(threadId)}/report`;
};

// Editovat
export const edit = (threadId: string) => {
  return `${basePath(threadId)}/msg_edit`;
};

// 'Tleskáček'
export const like = (threadId: string) => {
  return `${basePath(threadId)}/set_rating`;
};

// 'Výběr redakce'
export const tip = (threadId: string, state: string) => {
  return `/diskuse/${threadId}/1/${state !== 'f' ? 'un' : ''}markAsTip`;
};

// 'Slovník zakázaných výrazů'
export const badWords = (threadId: string) => {
  return `${basePath(threadId)}/badwords`;
};
